// @ts-expect-error lib não tem tipos ainda
import { Logger } from '@tecsinapse-org/logger'
import { UAParser } from 'ua-parser-js'
import { version } from '../../../package.json'

const { browser, device } = new UAParser().getResult()
const kcInfo = localStorage.getItem('_KC_INFO')

const isProd = import.meta.env.VITE_PROFILE === 'production'
const env = isProd ? 'prod' : 'dev'

export const logger = new Logger({
  environment: env,
  projectName: 'portal',
  tags: {
    product: 'portal',
    project: 'portal-ui',
    client: kcInfo ? JSON.parse(kcInfo).realm : 'unknown',
    env,
    provisioner: 'serveless'
  },
  metadata: {
    model: browser.name,
    endpoint: import.meta.env.VITE_API_URL,
    appVersion: version,
    custom: {
      deviceModel: String(device.model)
    }
  }
})

logger
  .initialize()
  .then(() => (!isProd ? console.info('Logs initialized') : null))
  .catch((e: Error) => console.error('Error in create group and log stream', e))
